import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Http, RequestOptions, Headers, Response } from '@angular/http';
import { ProfileService } from '../services/profile.service';
import { environment } from '../../../environments/environment';
// import { map } from 'rxjs/operators';
// import 'rxjs/add/operator/catch';

// import 'rxjs/add/operator/map';
// import { Observable  } from 'rxjs';

@Component({
    selector: 'upload-fileDialog',
    templateUrl: './uploadFile.component.html',
})
export class UploadFileDialogComponent {
    public SearchValue: string = null;
    private Message: string = "";
    private IsMsg: boolean = false;
    public DownloadFileUrl = "";


    constructor(public dialogRef: MatDialogRef<UploadFileDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string, public vcRef: ViewContainerRef, private ProfileService: ProfileService, private http: Http) {
        console.log(data);
        dialogRef.disableClose = true;
        this.DownloadFileUrl = environment.baseAPIUrl + "Employer/DownloadFile"
    }

    ngOnInit() { }

    onNoClick(): void {
        this.dialogRef.close();
    }

    fileChange(event) {
        debugger;
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            let file: File = fileList[0];
            let formData: FormData = new FormData();
            formData.append('uploadFile', file, file.name);
            this.ProfileService.UploadBulkRecord(formData).subscribe(result => this.UploadBulkRecordSuccess(result), result => this.UploadBulkRecordError(result))

        }
    }

    UploadBulkRecordSuccess(res) {
        console.log(res);


    }

    UploadBulkRecordError(res) {
        console.log(res)
        this.Message = res.json();
        this.IsMsg = true;
        if (this.Message == "File uploaded successfully.") {
            this.dialogRef.close();

        }

    }



}